module.exports = __webpack_public_path__ + "img/gxl.b312ff25.b312ff25.svg";